// extracted by mini-css-extract-plugin
export default {"posReal":"city_posReal__3NvXV","selectcastom":"city_selectcastom__ffJbe","scroll":"city_scroll__5HDoB","citysel":"city_citysel__7e2po","showcas":"city_showcas__Si3X5"};